<template>
    <div>
        <div v-if="!waitForLogin">
            <p class="font-weight-bold pb-1">In der ÖSKB App anmelden</p>
        <!-- regular login -->
            <v-form ref="form" lazy-validation v-if="rules" @submit.prevent>
                <v-row no-gutters align="center">
                    <v-col class="grow">
                        <v-text-field v-model="email" label="E-Mail-Adresse" @keyup="enterOnEmail($event)"
                                      :rules="[rules.required, rules.email]"
                                      outlined dense clearable></v-text-field>
                    </v-col>
                    <v-col class="shrink pb-7 pl-3">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on"
                                        @click="saveEmail()">
                                    mdi-content-save
                                </v-icon>
                            </template>
                            <span>Email-Adresse für nächste Anmeldung merken</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <div v-if="!emailStatus">
                    <v-btn depressed block color="secondary" @click="verifyEmail()"
                           class="mb-3">Weiter</v-btn>
                </div>
                <div v-else-if="emailStatus==='notPending'">
                    <v-text-field v-model="password" label="Passwort" @keyup="enterOnPW($event)"
                                  :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="showPW ? 'text' : 'password'"
                                  :rules="[rules.required, rules.password.min]"
                                  @click:append="showPW = !showPW"
                                  outlined dense clearable></v-text-field>
                    <div v-if="confirmMissing" class="error--text caption text-left mb-5">
                        Du hast das E-Mail nicht bekommen? Klicke hier für ein neues E-Mail:
                        <span class="text--primary text-decoration-underline" @click="resendConfirmMail()">
                        {{confirmMissing}}</span>
                    </div>
                    <v-btn depressed block color="secondary" @click="login()">Anmelden</v-btn>
                    <!-- forgot password -->
                    <v-btn text small block color="secondary" class="mt-3 no-uppercase"
                           @click="navigate('resetPW')">Passwort vergessen?</v-btn>
                </div>
                <div v-else-if="emailStatus==='pending'">
                    <p>Das ist deine erste Anmeldung, du musst daher noch dein Passwort setzen.</p>
                    <p> Wir haben dir dazu eine E-Mail geschickt.
                        Bitte klicke auf den Link darin um dein Passwort zu erstellen und dich anzumelden.</p>
                </div>
                <error-msg :error="errorMsg"></error-msg>
            </v-form>
        <!-- email saved snackbar -->
            <v-snackbar v-model="snackbar" color="success">
                Deine email-Adresse wurde für zukünftige Anmeldungen gespeichert!
            </v-snackbar>
        <!-- sign up
            <divider-with-text :text="$t('basic.or')" class="my-2"></divider-with-text>
            <v-btn depressed block @click="navigate('signup')">{{$t('login.newAccount')}}</v-btn>-->
        </div>
    <!-- spinner for waiting time for sign up and email creation -->
        <v-progress-circular indeterminate color="secondary" v-else></v-progress-circular>
    </div>
</template>

<script>
    import {FormRules} from "../../services/formRules";
    import firebase from 'firebase/app'
    import 'firebase/auth'
    import ErrorMsg from "../../components/elements/errorMsg";
    import { db } from '../../services/db'

    export default {
        components: { ErrorMsg},
        name: 'with-e-mail-login',
        data: () => ({
            emailStatus: '',
            email: '',
            password: '',
            showPW: false,
            rules: null,
            errorMsg: '',
            confirmMissing: '',
            waitForLogin: false,
            snackbar: false,
            //languageOptions: [{i18n: 'Deutsch', value: 'de'}, {i18n: 'English', value: 'en'}],
        }),
        created(){
            this.rules = new FormRules;
            const emailSaved = localStorage.getItem('email');
            if ( emailSaved ) {  this.email = emailSaved; }
        },
        methods: {
            enterOnEmail(e){
                if ( e.keyCode === 13 ) {
                    this.verifyEmail();
                }
            },
            enterOnPW(e){
                if ( e.keyCode === 13 ) {
                    this.login();
                }
            },
            login() {
                if( !this.$refs.form.validate() ) { return }
                if ( this.$store.state.user.uid && !this.$store.state.user.emailVerified ) {
                    this.checkVerification();
                    return
                }
                this.waitForLogin = true;
                firebase.auth().setPersistence(firebase.auth.Auth.Persistence[this.$store.state.config.persistence])
                    .then(() => {
                        // Existing and future Auth states are now persisted in the current
                        // session only. Closing the window would clear any existing state even
                        // if a user forgets to sign out.
                        // ...
                        // New sign-in will be persisted with session persistence.
                        firebase.auth().signInWithEmailAndPassword(this.email.trim(), this.password)
                            .then(() => {
                                this.waitForLogin = false;
                            })
                            .catch((error) => {
                                this.waitForLogin = false;
                                this.loginError(error);
                            });
                    })
                    .catch((error) => {
                        this.waitForLogin = false;
                        this.loginError(error);
                    });
            },
                loginError(error) {
                    console.log ("errorCode: ", error.message);
                    let errMessage = "";
                    switch (error.code) {
                        case 'auth/invalid-email':
                            errMessage = 'Bitte gültige E-Mail-Adresse eingeben!'; break;
                        case 'auth/user-not-found':
                            errMessage = 'Zu dieser E-Mail-Adresse gibt es kein Konto.'; break;
                        case 'auth/wrong-password':
                            errMessage = 'Das Passwort ist falsch!'; break;
                        case 'auth/too-many-requests':
                            errMessage = 'Der Zugriff auf dieses Konto wurde aufgrund zahlreicher fehlgeschlagener ' +
                                'Anmeldeversuche vorübergehend deaktiviert. Du kannst es wiederherstellen, ' +
                                'indem du dein Passwort zurücksetzt, oder du kannst es später erneut versuchen.';
                            break;
                        default:
                            console.log ("errorCode: ", error.code);
                            this.errorMsg = error.message;
                            return
                    }
                    this.errorMsg = errMessage;
                },
            checkVerification(){
                firebase.auth().currentUser.reload().then(() => {
                    if ( firebase.auth().currentUser.emailVerified ) {
                        this.completeSignUp();
                    } else {
                        this.errorMsg = "Du hast ein E-Mail mit einem Bestätigungslink erhalten. " +
                            "Bitte klicke auf den Link in der E-Mail um dein Konto zu aktivieren.",
                        this.confirmMissing = 'E-Mail nochmal senden';
                    }
                }).catch((error) => {
                    console.log ("Error: ", error);
                    this.close();
                });
            },
            verifyEmail(){
                console.log ("verifyEmail");
                if ( !this.email ) { this.errorMsg = 'Bitte eine gültige eMail Adresse eingeben!'; return  }
                this.errorMsg = '';
                const docRef = db.collection('users_pending');
                docRef.where( 'email', '==', this.email ).get()
                    .then((querySnapshot) => {
                        if ( querySnapshot.docs.length > 0 ) {
                            this.emailStatus = 'pending';
                            this.sendPasswordMail();
                        } else {
                            this.emailStatus = 'notPending';
                        }
                    })
                    .catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
                sendPasswordMail(){
                    firebase.auth().sendPasswordResetEmail(this.email);
                },
            async completeSignUp () {
                const pendingUser = await this.$store.dispatch('dbGetSingleDoc', {
                    uid: firebase.auth().currentUser.uid,
                    collection: 'usersPending',
                    mutuation: '',
                });
                if ( pendingUser ) {
                    this.addAppUserToDB(pendingUser.data());
                    this.deletePendingUser();
                }
            },
            async addAppUserToDB(data){
                let dbUpdate = await this.$store.dispatch('dbWriteDocWithID', {
                    collection: 'users',
                    docID: firebase.auth().currentUser.uid,
                    data: data,
                    mutuation: 'user/setFromAppData'
                });
                if (dbUpdate) { this.$store.commit('user/emailVerified') }
            },
            async deletePendingUser() {
                await this.$store.dispatch('dbDeleteDocByID', {
                    collection: 'usersPending',
                    docID: firebase.auth().currentUser.uid,
                    mutuation: ''
                });
            },
            resendConfirmMail(){
                this.confirmMissing = 'Das E-Mail wurde versendet!';
                firebase.auth().languageCode = 'de';
                firebase.auth().currentUser.sendEmailVerification().then(() => {
                }).catch(() => {
                    this.errorMsg = 'Beim Senden des E-Mails ist ein Fehler aufgetreten!';
                    this.confirmMissing = 'E-Mail nochmal senden';
                });
            },
            navigate(action) {
                this.$emit('navigate', action)
            },
            saveEmail(){
                localStorage.setItem('email', this.email);
                this.snackbar = true;
            }
        }
    }
</script>

<style scoped>
    .no-uppercase { text-transform: none; }
</style>